// eslint-disable-next-line import/prefer-default-export
export const StudyTypes = {
  ADD_CLASSES: 'ADD_CLASSES',
  ADD_ACTIVE_CLASS: 'ADD_ACTIVE_CLASS',
};
